module.exports = __webpack_public_path__ + "static/media/3.95a080f7.png";